import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ["modal", "pdfEmbed", "object", "modalTitle"];
  static values = { url: String, name: String };

  connect() {
    this.closeModal();
  }

  openModal(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.pdfPreviewUrlValue;
    const name = event.currentTarget.dataset.pdfPreviewNameValue;

    // Get the parent container of the object
    const container = this.objectTarget.parentNode;

    // Remove the old object element
    this.objectTarget.remove();

    // Create a new object element
    const newObject = document.createElement('object');
    newObject.setAttribute('data', url);
    newObject.setAttribute('type', 'application/pdf');
    newObject.setAttribute('width', '100%');
    newObject.setAttribute('height', '600px');
    newObject.setAttribute('frameborder', '0');
    newObject.setAttribute('data-pdf-preview-target', 'object');

    // Create a new embed element inside the object
    const newEmbed = document.createElement('embed');
    newEmbed.setAttribute('src', url);
    newEmbed.setAttribute('class', 'w-full');
    newEmbed.setAttribute('width', '100%');
    newEmbed.setAttribute('height', '600');
    newEmbed.setAttribute('type', 'application/pdf');
    newEmbed.setAttribute('data-pdf-preview-target', 'pdfEmbed');

    // Add the embed to the object
    newObject.appendChild(newEmbed);

    // Add the new object to the container
    container.appendChild(newObject);

    // Update modal title
    this.modalTitleTarget.textContent = name || "PDF Preview";

    // Show modal
    this.modalTarget.classList.remove("hidden");
  }

  closeModal() {
    // Hide modal
    this.modalTarget.classList.add("hidden");

    // We don't need to clear the object/embed since we'll replace them on next open
    this.modalTitleTarget.textContent = "";
  }
}
